import { render, staticRenderFns } from "./RequestLink.vue?vue&type=template&id=5737e72f&"
import script from "./RequestLink.vue?vue&type=script&lang=js&"
export * from "./RequestLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RequestLink.vue"
export default component.exports